export default __webpack_public_path__ + "static/iot2-b2ad2906cd5c3fd4b6ac05047a88c507.png";